export default "__VITE_ASSET__TaX7hP_O__"